/* eslint-disable no-unused-vars */
/* eslint-disable space-before-function-paren */
/* eslint-disable indent */
import React, { memo, useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContextProvider'
import { detectLinuxBaseOS } from '../util/util'

function CountDown(LotteryName) {
    const { lotteryState } = useContext(AppContext)
    const [countdownTime, setCountdownTime] = useState(
        {
            countdownHours: '',
            countdownMinutes: '',
            countdownSeconds: ''
        }
    )
    const isLinuxBaseOs = detectLinuxBaseOS()
    const drawDateTime = LotteryName.LotteryName ? lotteryState[LotteryName.LotteryName]?.draw_date_time : lotteryState?.draw_date_time

    useEffect(() => {
        if (drawDateTime && drawDateTime !== 'null') {
            const timeInterval = setInterval(() => {
                const countdownDateTime = new Date(drawDateTime).getTime()
                const currentTime = new Date().getTime()
                const remainingDayTime = countdownDateTime - currentTime
                const totalHours = Math.floor((remainingDayTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                const totalMinutes = Math.floor((remainingDayTime % (1000 * 60 * 60)) / (1000 * 60))
                const totalSeconds = Math.floor((remainingDayTime % (1000 * 60)) / 1000)

                const runningCountdownTime = {
                    countdownHours: totalHours.toString(),
                    countdownMinutes: totalMinutes.toString(),
                    countdownSeconds: totalSeconds.toString()
                }

                setCountdownTime(runningCountdownTime)

                if (remainingDayTime < 0) {
                    clearInterval(timeInterval)
                }
            }, 1000)
        }
    }, [lotteryState])

    return <div className="countdown-wrapper">
        <div className='countdown-group-wrapper'>
            <div className='countdown-group'>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownHours.length !== 1 ? countdownTime.countdownHours.split('')[0] : 0}
                </div>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownHours.length === 1 ? countdownTime.countdownHours.split('')[0] : countdownTime.countdownHours.split('')[1]}
                </div>
            </div>
            <div className='countdown-group-label'>
                hours
            </div>
        </div>
        <div className='countdown-group-separator' style={{ marginTop: isLinuxBaseOs ? -8 : -5 }}>
            :
        </div>
        <div className='countdown-group-wrapper'>
            <div className='countdown-group'>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownMinutes.length !== 1 ? countdownTime.countdownMinutes.split('')[0] : 0}
                </div>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownMinutes.length === 1 ? countdownTime.countdownMinutes.split('')[0] : countdownTime.countdownMinutes.split('')[1]}
                </div>
            </div>
            <div className='countdown-group-label'>
                minutes
            </div>
        </div>
        <div className='countdown-group-separator' style={{ marginTop: isLinuxBaseOs ? -8 : -5 }}>
            :
        </div>
        <div className='countdown-group-wrapper'>
            <div className='countdown-group'>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownSeconds.length !== 1 ? countdownTime.countdownSeconds.split('')[0] : 0}
                </div>
                <div className="countdown-box" style={{ paddingTop: isLinuxBaseOs ? 0 : 2, paddingBottom: isLinuxBaseOs ? 3 : 0 }}>
                    {countdownTime.countdownSeconds.length === 1 ? countdownTime.countdownSeconds.split('')[0] : countdownTime.countdownSeconds.split('')[1]}
                </div>
            </div>
            <div className='countdown-group-label'>
                seconds
            </div>
        </div>

    </div>
}

CountDown.propTypes = {}

export default memo(CountDown)
